import React from 'react';

export const path =
  'M7,13 C3.6862915,13 1,10.3137085 1,7 C1,3.6862915 3.6862915,1 7,1 C10.3137085,1 13,3.6862915 13,7 C13,10.3137085 10.3137085,13 7,13 Z M7,5 C7.55228475,5 8,4.55228475 8,4 C8,3.44771525 7.55228475,3 7,3 C6.44771525,3 6,3.44771525 6,4 C6,4.55228475 6.44771525,5 7,5 Z M6.25,6 C6.11192881,6 6,6.11192881 6,6.25 L6,10.75 C6,10.8880712 6.11192881,11 6.25,11 L7.75,11 C7.88807119,11 8,10.8880712 8,10.75 L8,6.25 C8,6.11192881 7.88807119,6 7.75,6 L6.25,6 Z';

export default class Info extends React.PureComponent {
  render() {
    return <path d={path} className="fill-current" />;
  }
}
